import React from "react";

import useLayoutData from "@/hooks/useLayoutData";

const ToobarOffset = () => {
  const { toolbarHeight } = useLayoutData();

  return <div className="w-full" style={{ height: toolbarHeight + "px" }} />;
};

export default React.memo(ToobarOffset);
